module.exports = __webpack_public_path__ + "img/type_curtain_mega.ac4017f2.jpg";